<template>
  <div class="page-wrapper">
    <Header />
    <main class="page-main">
      <VideoSection />
      <HeroHome />
      <ProblemSection />
      <MethodSection />
      <HowWeWorkSection />
      <FinalCTASection />
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '../components/Header.vue';
import HeroHome from '../components/Home/HeroHome.vue';
import ProblemSection from '../components/Home/ProblemSection.vue';
import MethodSection from '../components/Home/MethodSection.vue';
import VideoSection from '../components/Home/VideoSection.vue';
import HowWeWorkSection from '../components/Home/HowWeWorkSection.vue';
import FinalCTASection from '../components/FinalCTASection.vue';
import Footer from '../components/Footer.vue';

export default {
  components: {
    Header,
    HeroHome,
    ProblemSection,
    MethodSection,
    VideoSection,
    HowWeWorkSection,
    FinalCTASection,
    Footer
  }
};
</script>
